import { ValidatorService } from "../../../service/validatorService";

const validateField = (value, min, max) => {
  return (
    ValidatorService.isMin(value, min) || ValidatorService.isMax(value, max)
  );
};

export const VALIDATORS = {
  nom: (value) => validateField(value, 3, 30),
  prenom: (value) => validateField(value, 3, 30),
  email: (value) => ValidatorService.isEmailCorrect(value),
  tel: (value) => ValidatorService.isPhoneCorrect(value),
  sujet: () => "",
  message: (value) => validateField(value, 10, 10000),
};
